
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11.701 4.12L7.822 2.212 3.943 4.12l-.967 4.327 2.699 3.457H9.97l2.698-3.457-.967-4.327zM8.357 1.124a1.211 1.211 0 00-1.07 0L3.408 3.032a1.212 1.212 0 00-.647.823l-.968 4.328c-.035.16-.038.323-.01.48l-.697.343a.8.8 0 00-.428.544L.02 12.409a.8.8 0 00.15.667l1.783 2.283a.8.8 0 00.631.308h2.838a.8.8 0 00.63-.308l1.753-2.244h.392L9.95 15.36a.8.8 0 00.63.308h2.838a.8.8 0 00.63-.308l1.783-2.283a.8.8 0 00.15-.667l-.638-2.86a.8.8 0 00-.428-.543l-1.035-.51a1.207 1.207 0 00-.028-.313l-.968-4.328a1.212 1.212 0 00-.647-.823l-3.88-1.908zm5.227 8.12l-2.66 3.406a1.21 1.21 0 01-.954.465h-.758l1.367 1.752h2.838l1.783-2.284-.64-2.859-.976-.48zm-6.796 3.871H5.675a1.21 1.21 0 01-.955-.465L2.16 9.37l-.72.354-.64 2.86 1.783 2.283h2.838l1.367-1.752zm1.034-8.177a2.423 2.423 0 10.001 4.847 2.423 2.423 0 000-4.847zM6.611 7.362a1.212 1.212 0 112.423 0 1.212 1.212 0 01-2.423 0z"}})])
          )
        }
      }
    